<template>
<main id="investments-page">
    <section>

        <article class="print-hide">
            <h1>Welcome, {{user.first_name}} {{user.last_name}}</h1>
        </article>

        <article>
            <section>
                <h1>Account Details <span class="print-only">for {{user.first_name}} {{user.last_name}}</span></h1>
            </section>
            <section class="shares-data">
                <article>
                    <div class="investment-card">
                        <label>
                            Last Share Price
                        </label>
                        <h2>
                            ${{currentShareValue}}
                        </h2>
                        <!-- <span v-if="investments.length != 0 & currentShareValue - averageSharePrice != 0">
                            <span v-if="currentShareValue - averageSharePrice > 0">+{{roundPrices(currentShareValue - averageSharePrice)}}</span>
                            <span v-else>-{{roundPrices(currentShareValue - averageSharePrice)}}</span>
                        </span> -->

                    </div>
                </article>
                <article>
                    <div class="investment-card">

                        <label>
                            Your Shares
                        </label>
                        <h2>
                            {{numberWithCommas(totalShares)}}
                        </h2>

                    </div>
                </article>
                <article>
                    <div class="investment-card">

                        <label>
                            Current Value
                        </label>
                        <h2>
                            ${{numberWithCommas(numberSetPrecision(totalValue,0))}}
                        </h2>
                        <!-- <span v-if="investments.length!=0 & totalCapital!=0 & capitalPercentage != 0">
                            <span class="capital-percentage" v-if="totalCapital>0">{{capitalPercentage}}%</span>
                            <span class="capital-percentage" v-else>{{capitalPercentage}}%</span>
                        </span> -->

                    </div>
                </article>
                <article>
                    <div class="investment-card">

                        <label>
                           Your Average Share Price
                        </label>
                        <h2 v-if="investments.length!=0">
                            ${{numberWithCommas(averageSharePrice)}}
                        </h2>
                        <span v-else>
                            $0
                        </span>

                    </div>
                </article>
                <article>
                    <div class="investment-card">

                        <label>
                            Capital Contribution
                        </label>
                        <h2 v-if="investments.length!=0">
                            ${{numberWithCommas(totalCapital)}}
                        </h2>
                        <span v-else>
                            $0
                        </span>

                    </div>
                </article>
                <article>
                    <div class="investment-card">

                        <label>
                            Change
                        </label>
                        <h2 v-if="investments.length!=0">
                            {{capitalGain>0?'+':''}}${{numberWithCommas(numberSetPrecision(capitalGain, 0))}}
                        </h2>
                        <span v-else>
                            $0
                        </span>

                    </div>
                </article>
            </section>
            <section class="investments-section">
                <h1>Investments</h1>
                <div class="investments">
                    <div class="investment-card-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <a>
                                            Date
                                        </a>
                                    </th>
                                    <th>
                                        <a>
                                            Purchaser
                                        </a>
                                    </th>
                                    <th>
                                        <a>
                                            Shares
                                        </a>
                                    </th>
                                    <th>
                                        <a>
                                            Capital
                                        </a>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="investment in sortedInvestments" :key="investment.investment_id">
                                    <td>{{investment.transaction_date | simple_date}}</td>
                                    <td>{{investment.purchaser}}</td>
                                    <td>{{numberWithCommas(investment.shares)}}</td>
                                    <td>${{numberWithCommas(investment.capital)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </section>			
        </article>
    </section>
</main>
</template>

<script>
import store from "@/store";
import {
    mapGetters
} from 'vuex';
import Utility from "@/../submodules/vue-base/mixins/Utility";
import KolkinSharesGraph from "@/components/investments/KolkinSharesGraph";
import Cover from "@/components/layout/Cover.vue";
import InvestorBody from "@/components/layout/InvestorBody.vue";

export default {
    name: "Investments",

    components: {
        KolkinSharesGraph,
        Cover,
        InvestorBody,
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch("getInvestments").then(function () {
            store.dispatch("loadSharesData").then(function () {
                next();
            });
        })

    },

    beforeRouteUpdate(to, from, next) {
        store.dispatch("getInvestments").then(function () {
            store.dispatch("loadSharesData").then(function () {
                next();
            });
        }).catch(function () {
            next({
                name: "home"
            })
        });

    },

    mixins: [
        Utility
    ],

    methods: {
        roundPrices(input) {
            var cents = input * 100; // ... is 7.5 cents
            var roundedCents = Math.round(cents); // ... but should really be 8 cents
            var roundedPrice = roundedCents / 100; // ... so it's 0.08 dollars in the end

            return roundedPrice
        },
    },

    computed: {

        capitalPercentage() {

			var capital = this.totalCapital;
            var shares = this.totalShares;
            var trueAverageSharePrice = capital / shares;
			

            var total_worth = this.totalShares * trueAverageSharePrice;
            var current_worth = this.totalShares * this.currentShareValue;
            var result = ((current_worth - total_worth) / total_worth) * 100;

			if (result < 0) {
                result = Math.abs(result);
            }

			return this.numberSetPrecision(result, 0);
        },

        capitalGain() {
            var current_worth = this.totalShares * this.currentShareValue;

            return this.numberSetPrecision(current_worth - this.totalCapital, 2);
        },

        currentShareValue() {
            if (this.dayOfSharesData.length == 0) {
                return 0;
            }
            return this.numberSetPrecision(this.dayOfSharesData[this.dayOfSharesData.length - 1].price_per_share, 2);
        },

        averageSharePrice() {
            var result = 0;
            var capital = this.totalCapital;
            var shares = this.totalShares;
            result = capital / shares;
            return this.numberSetPrecision(result, 2);
        },

        totalValue() {
            console.log(this.totalShares, this.currentShareValue);
            return this.numberSetPrecision(this.totalShares * this.currentShareValue, 2);
        },

        totalShares() {
            var result = 0;
            for (var i = 0; i < this.investments.length; i++) {
                result += parseInt(this.investments[i].shares);
            }
            return result;
        },

        totalCapital() {
            var result = 0;
            for (var i = 0; i < this.investments.length; i++) {
                result += parseInt(this.investments[i].capital);
            }
            return result;
        },
        sortedInvestments() {
            // The server returns oldest first; list the most recent investment at the top.
            // transaction_date is a yyyy-MM-dd string, so a string compare is chronological.
            return this.investments.slice().sort(function (a, b) {
                return String(b.transaction_date).localeCompare(String(a.transaction_date));
            });
        },
        ...mapGetters(["user", "dayOfSharesData", "investments", "investedShares"])
    }
}
</script>
